const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;

class ClarityService {
  init() {
    if (!CLARITY_ID) return;

    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_ID);
  }

  identify({ id, name, organizationName, organizationDocument }) {
    if (!CLARITY_ID) return;
    if (!id) return;

    if (typeof window.clarity === "function") {
      window.clarity("identify", id, null, null, name);
      window.clarity("set", "organizationName", organizationName);
      window.clarity("set", "organizationDocument", organizationDocument);
    }
  }
}

const clarityService = new ClarityService();
export default clarityService;
